'use client';

import { useEffect } from 'react';

declare global {
  interface Window {
    comet?: (command: string) => void;
  }
}

const CometlyScript = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const script = document.createElement('script');
      script.src =
        'https://data.trypennie.com/script.js?uid=42cb2f-4503599670000001-c321fd-s&domains=penniefunding.com,penniefinance.com,trypennie.com,discoverpennie.com,fundedbyreserve.com,reservealoan.com,trypennienow.com,reservelending.com,reserveyourloan.com,applywithpennie.com,reserveml.com,gopennie.com,fundedbypennie.com,itspennie.com,poweredbypennie.com,choosepennie.com,startwithpennie.com,loansbypennie.com,lendingbypennie.com,reservemyloan.com,selectpennie.com';
      script.async = true;
      script.setAttribute('data-ctag', 'cmt');
      script.onload = () => {
        if (window.comet) {
          window.comet('init');
        }
      };
      document.head.appendChild(script);
    }
  }, []);

  return null;
};

export default CometlyScript;
